import client from "./client";

export const getCommCode = (gropCd) =>
    client.get('/kognr/commCode', {
        params: {
            gropCd
        }
    });
